import { Component, OnInit, Injector, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { WorkOrderSearchFormComponent } from '../../forms/work-order-search-form/work-order-search-form.component';
import { WorkOrderSearchKeywordFormComponent } from '../../forms/work-order-search-keyword-form/work-order-search-keyword-form.component';
import { WorkOrdersService } from '../../work-orders.service';

@Component({
  selector: 'work-order-search-dialog',
  templateUrl: './work-order-search-dialog.component.html',
  styleUrls: ['./work-order-search-dialog.component.scss']
})
export class WorkOrderSearchDialogComponent implements OnInit {
  data: any = {};
  keywordButtonDisable = false;
  searchButtonDisable = false;
  workOrdersService: WorkOrdersService;
  @ViewChild(WorkOrderSearchFormComponent, { static: true }) woSearchComponent: any;
  @ViewChild(WorkOrderSearchKeywordFormComponent, { static: true }) woKeywordSearchComponent: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<WorkOrderSearchDialogComponent>,
    injector: Injector
  ) {
    this.data = data;
    this.workOrdersService = injector.get(WorkOrdersService);
  }

  ngOnInit() {
    // TO DO: Form Validation - disable Keyword Search when
    // using Custom Search Tool and vice versa
  }

  onKeywordYesClick() {
    const formData = this.woKeywordSearchComponent.editForm.value;
    this.dialogRef.close(formData);
  }

  onYesClick(): any {
    const formData = this.woSearchComponent.editForm.value;
    this.dialogRef.close(formData);
  }

  onNoClick(): void {
    this.workOrdersService.setIsSearch = false;
    this.dialogRef.close();
  }

  isDisabled() {
    return this.searchButtonDisable;
  }

  isKeywordDisabled() {
    return this.keywordButtonDisable;
  }

  onKeywordFormChanges() {
    this.woKeywordSearchComponent.editForm.valueChanges
      .subscribe(input => {
        if (input === '' || input === null || input === undefined) {
          this.woSearchComponent.editForm.enable();
          this.searchButtonDisable = false;
        } else {
          this.woSearchComponent.editForm.disable();
          this.searchButtonDisable = true;
        }
      });
  }

  onSearchFormChanges() {
    this.woSearchComponent.editForm.valueChanges
      .subscribe(input => {
        if ((input.AssignedEngineer === undefined || input.AssignedEngineer === null)
          && (input.DeliverableId === undefined || input.DeliverableId === null)
          && (input.PlantId === undefined || input.PlantId === null)
          && (input.ProgramId === undefined || input.ProgramId === null)
          && (input.Requestor === undefined || input.Requestor === null)) {
          this.woKeywordSearchComponent.editForm.get('TextSearch').enable();
          this.keywordButtonDisable = false;
        } else {
          this.woKeywordSearchComponent.editForm.get('TextSearch').disable();
          this.keywordButtonDisable = true;
        }
      });
  }
}
